import { MuiTelInput } from "mui-tel-input";
import { success } from "../assets";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setHours, setMinutes } from "date-fns";
import { l } from "./constants";
import { useEffect, useState } from "react";

export default function ChatBotForm({
  submitted,
  handleSubmit,
  reset,
  submitting,
  phone,
  setPhone,
  setCountry,
  startDate,
  setStartDate,
  language,
  onCancel,
}) {
  const [userCountryCode, setUserCountryCode] = useState("GB");

  useEffect(() => {
    const fetchUserCountry = async () => {
      const request = await fetch(
        "https://ipinfo.io/json?token=9cb24768da54fe"
      );
      const jsonResponse = await request.json();
      setUserCountryCode(jsonResponse?.country || "GB");
    };

    fetchUserCountry();
  }, []);

  if (submitted) {
    setTimeout(() => {
      reset(false);
    }, 5000);
  }
  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  const minTime = isToday(startDate)
    ? new Date()
    : setHours(setMinutes(new Date(), 0), 0);
  const maxTime = setHours(setMinutes(new Date(), 45), 23);

  return !submitted ? (
    <form
      onSubmit={handleSubmit}
      className="mt-1 w-full px-5 flex flex-col gap-[13px] md:gap-[15px] "
    >
      <div className="flex w-full justify-between gap-3 md:gap-5">
        <input
          className="py-[9px] px-[10px] text-[12px] w-full h-10 border border-[#E3E3E3] outline-0 text-[#737373] bg-transparent rounded-[8px]"
          required
          type="text"
          placeholder="Full Name"
          id="first_name"
          name="first_name"
        />
      </div>
      <div className="field">
        <input
          className="py-[9px] px-[10px] text-[12px] w-full h-10 border border-[#E3E3E3] outline-0 text-[#737373] bg-transparent rounded-[8px]"
          required
          type="text"
          placeholder="Email"
          id="email"
          name="email"
        />
      </div>
      <div className="field">
        <MuiTelInput
          id="phone"
          value={phone}
          defaultCountry={userCountryCode}
          onChange={(val, details) => {
            setPhone(val);
            setCountry(details?.countryCode);
          }}
          className="w-full text-[#737373]"
          placeholder="Phone number"
        />
      </div>
      <DatePicker
        selected={startDate}
        onChange={(date) => setStartDate(date)}
        className="py-[9px] px-[10px] text-[12px] w-full h-10 border border-[#E3E3E3] outline-0 text-[#737373] bg-transparent rounded-[8px]"
        placeholderText="Select Date and Time"
        showTimeSelect
        timeFormat="HH:mm"
        minDate={new Date()}
        minTime={minTime}
        maxTime={maxTime}
        timeIntervals={15}
        dateFormat="MMMM d, yyyy h:mm aa"
        timeCaption="time"
        id="date"
      />
      <div className="field">
        <textarea
          rows={2}
          className="py-[9px] px-[10px] text-[12px] w-full h-10 border border-[#E3E3E3] outline-0 text-[#737373] bg-transparent rounded-[8px]"
          type="text"
          placeholder="Reason for callback"
          id="note"
          name="note"
        />
      </div>
      <div className="w-full flex gap-3 md:gap-5 mx-auto justify-between mt-1">
        <button
          type="reset"
          onClick={onCancel}
          className="w-full flex border border-poppingBlue text-poppingBlue outline-0 justify-center items-center px-[56px] text-[14px] font-semibold py-[8px] bg-inherit rounded-[100px]"
        >
          Cancel
        </button>
        <button
          disabled={submitting}
          type="submit"
          className="w-full flex justify-center text-white items-center px-[56px] text-[14px] font-semibold py-[8px] btn-sweep btn-sweep-blue rounded-[100px]"
        >
          {submitting ? "Submitting" : "Submit"}
        </button>
      </div>
    </form>
  ) : (
    <div className="flex flex-col items-center justify-center gap-5 mt-[30%]">
      <img src={success} alt="Success" />
      <p className="text-[14px] text-white leading-[180%] max-w-[235px] mx-auto text-center">
        {l[language]?.infoTexts?.callRequestSuccess}
      </p>
    </div>
  );
}
